<audio class="d-block w-100" controls #audioElement>
  <source [src]="materialUrl" type="{{ material.mimetype }}" />
  {{ "demo.educationalMaterial.preview.noAudioSupport" | translate }}
</audio>
